import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";

const applyTheme = (theme) => {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.classList.toggle("light", theme !== "dark");
  localStorage.setItem("theme", theme);
};

export default function DarkMode() {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const preferredTheme = localStorage.getItem("theme") === "dark" ? "dark" : "light";
    applyTheme(preferredTheme);
    setIsEnabled(preferredTheme === "dark");
  }, []);

  const toggleTheme = () => {
    const nextTheme = isEnabled ? "light" : "dark";
    applyTheme(nextTheme);
    setIsEnabled(nextTheme === "dark");
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="box dark-mode-switcher mx-1 flex items-center justify-center rounded-full border p-2 shadow-md dark:bg-dark-2"
      aria-label={isEnabled ? "فعال‌کردن حالت روشن" : "فعال‌کردن حالت تیره"}
      title={isEnabled ? "حالت روشن" : "حالت تیره"}
    >
      {isEnabled ? (
        <Icons.Sun aria-hidden="true" className="mx-1 text-gray-300" />
      ) : (
        <Icons.Moon aria-hidden="true" className="mx-1 text-gray-700" />
      )}
    </button>
  );
}
